<template>
  <div class="row" style="margin-bottom: 17px; margin-top: 20px;">
    <div class="col-12 padd-0">
      <p
        class="m-color"
        style="text-align: left;"
      >{{assignedId.includes('_rep_msg_') ? 'Off Hours reply for customer response' : 'Message to Send'}}</p>

      <tagify :id="assignedId" :value="msg_body" :settings="tagifySettings"></tagify>
    </div>
  </div>
</template>

<script>
import tagify from "../../../tagify/tagify.vue";
export default {
  name: "flpMsgContainer",
  components: {
    tagify
  },
  props: {
    msg_body: String,
    allowed: Boolean,
    assignedId: String
  },
  data() {
    return {
      tagifySettings: {
        whitelist: [
          "UserFullName",
          "UserFirstName",
          "UserLastName",
          "UserPhone",
          "VehicleMake",
          "VehicleModel",
          "VehicleYear",
          "CustNo",
          "ServiceLink"
        ],
        enforceWhitelist: true,
        mode: "mix",
        mixTagsInterpolator: ["[[", "]]"],

        pattern: /\{\{/,
        duplicates: true,
        editTags: false,
        dropdown: {
          classname: "color-blue",
          enabled: 1, // show the dropdown immediately on focus
          maxItems: 10,
          position: "text", // place the dropdown near the typed text
          closeOnSelect: true, // keep the dropdown open after selecting a suggestion
          highlightFirst: true,
          fuzzySearch: true,
          mapValueTo: "disp"
        },
        callbacks: {
          add: this.msgFromInput,
          remove: this.msgFromInput,
          input: this.msgFromInput
        }
      }
    };
  },

  watch: {
    allowed: function(val) {
      this.MsgInputBoxStyling(val);
    }
  },

  mounted() {
    this.MsgInputBoxStyling(this.allowed);
  },

  methods: {
    MsgInputBoxStyling(val) {
      let bx = this.$el.querySelector(".tagify");
      if (val) {
        bx.classList.remove("tgf-disable-input");
      } else {
        bx.classList.add("tgf-disable-input");
      }
      bx.querySelector(".tagify__input").setAttribute("contenteditable", val);
    },

    msgFromInput() {
      this.$emit(
        "input",
        this.FormatMsgInput(this.$el.querySelector(`#${this.assignedId}`).value)
      );
    },

    FormatMsgInput(ss) {
      const matcherFix = new RegExp(/\[\[\{(.*?)\}\]\]/, "gm");
      const sliceFix = str => str.slice(2, -2);

      if (ss.match(matcherFix) != null) {
        let rs = ss.match(matcherFix).map(sliceFix);
        for (let i in rs) {
          ss = JSON.parse(rs[i]).value
            ? ss.replace(rs[i], `${JSON.parse(rs[i]).value}`)
            : ss;
        }
      }
      return ss;
    }
  }
};
</script>
<style scoped>
.padd-0 {
  padding: 0;
}
.m-color {
  color: #266db3;
}
</style>




